import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { ColumnDef } from './types';

export const BODY_CELL_SX = {
  borderBottom: '2px solid #e0e0e0',
  height: '52px',
  minHeight: '52px',
  paddingBottom: '8px',
  paddingTop: '8px',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
};

const TableSkeleton = <T,>({
  columns,
  getColWidthStyle,
  getStickyStyle,
  selectable,
}: {
  columns: ColumnDef<T>[];
  getColWidthStyle: (key: keyof T) => any;
  getStickyStyle: (key: keyof T | '__checkbox__', isHeader: boolean) => any;
  selectable: boolean;
}) => (
  <TableRow>
    {selectable && (
      <TableCell
        padding="checkbox"
        sx={{
          ...getStickyStyle('__checkbox__', false),
          borderBottom: '2px solid #e0e0e0',
        }}
      >
        <Checkbox disabled />
      </TableCell>
    )}
    {columns.map((col) => (
      <TableCell
        key={col.field as string}
        sx={{
          ...getStickyStyle(col.field, false),
          ...getColWidthStyle(col.field),
          ...BODY_CELL_SX,
        }}
      >
        <div style={{ backgroundColor: '#f0f0f0', height: '20px' }} />
      </TableCell>
    ))}
  </TableRow>
);

export default TableSkeleton;
